module.exports = __webpack_public_path__ + "img/17_terminos.70eab0c0.png";